import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const LVPIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M5.922 14.058H8.622V15.3H4.5V9H5.922V14.058ZM12.192 15.3H10.725L8.25 9H9.78L11.499 13.752L13.227 9H14.694L12.192 15.3ZM14.862 9H17.535C19.137 9 20.055 9.792 20.055 11.187C20.055 12.654 19.137 13.5 17.535 13.5H16.284V15.3H14.862V9ZM16.284 10.179V12.312H17.463C18.255 12.312 18.705 11.952 18.705 11.232C18.705 10.53 18.255 10.179 17.463 10.179H16.284Z'
                fill='currentColor'
            />
        </>
    ),
})

LVPIcon.displayName = 'LVPIcon'
